import { render, staticRenderFns } from "./ReportVoxis.vue?vue&type=template&id=b39d880a&scoped=true"
import script from "./ReportVoxis.vue?vue&type=script&lang=js"
export * from "./ReportVoxis.vue?vue&type=script&lang=js"
import style0 from "./ReportVoxis.vue?vue&type=style&index=0&id=b39d880a&prod&lang=scss"
import style1 from "./ReportVoxis.vue?vue&type=style&index=1&id=b39d880a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39d880a",
  null
  
)

export default component.exports